export const simberriesAndCreamPastry = {
  id: "simberriesAndCreamPastry",
  link: "/#/recipes/recipes/simberriesAndCreamPastry",
  name: "Simberries and Cream Pastry",
  cuisine: "Alethi",
  summary:
    "Lingonberry jam and cardamom pastry cream on crispy corn flour squares",
  inspiration: null,
  quantity: "About 16",
  time: "1 hour, plus additional time to chill",
  notes:
    "We know that the Alethi eat pastries (Oathbringer ch 69). Unfortunately we don't get any more detail than that. I had previously decided that lingonberries are our best match for simberries, and I was looking for a place to use them. They worked well here, with pastry cream to offset the tartness.",
  quotes:
    "I hear they've got storming good pastries at those fancy lighteyes parties. (Oathbringer ch 69)",
  image:
    "https://jozomby-public.s3.amazonaws.com/recipes/simberries-and-cream-pastry-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "lavisPastrySquares",
          display: "1 recipe Lavis Pastry Squares"
        },
        {
          item: "eggs",
          display: "2 egg yolks"
        },
        {
          item: "gelatin",
          display: "1/2 packet gelatin"
        },
        {
          item: "water",
          display: "1 1/2 tbsp cold water"
        },
        {
          item: "sugar",
          display: "6 tbsp granulated sugar"
        },
        {
          item: "cardamom",
          display: "1/4 tsp ground cardamom"
        },
        {
          item: "salt",
          display: "1/8 tsp salt"
        },
        {
          item: "corn",
          display: "2 tbsp corn starch"
        },
        {
          item: "dairy",
          display: "1 1/2 cups milk"
        },
        {
          item: "dairy",
          display: "2 tbsp butter"
        },
        {
          item: "lingonberryJam",
          display: "About 1/3 cup lingonberry jam"
        }
      ]
    }
  ],
  steps: [
    "Separate the egg yolks from the eggs, set aside in a small bowl. Use the egg whites for a different recipe. Add the 1 1/2 tbsp cold water to another small bowl. Sprinkle the gelatin over the water, then stir briefly to combine. Set aside.",
    "In a saucepan, combine the sugar, cardamom, salt and corn starch. Add the milk and stir until combined. Cook over medium high heat, stirring frequently, until thick and bubbly.",
    "Remove from heat. Take the bowl of egg yolks and beat them with a whisk just until combined. With the pot of thickened milk mixture in one hand, and the whisk in the other, pour a thin stream of milk mixture into the egg yolks, whisking the egg yolks as you do. The goal is to slowly combine the two without cooking the eggs. Continue to pour and whisk until you've poured about half the mixture.",
    "Reverse the process. Set the saucepan down, then pour a thin stream from the egg yolk bowl back into the pot, whisking the pot as you do so. Continue until everything has been returned to the pot. You should now have a yellow, somewhat thick mixture that does not have any cooked egg particles or chunks. If there is cooked egg, strain the mixture to remove the egg solids.",
    "Place the saucepan back over medium heat, cook until bubbly once more, then cook and stir for two more minutes.",
    "Remove from heat, then add the gelatin mixture (it will be set up and solid) and butter. Stir until butter melts.",
    "Pour mixture into a bowl, and cover with plastic wrap, settling the covering such that it touches the top of liquid. This will stop the pastry cream from forming a skin. Chill until cold.",
    "Meanwhile, prepare the Lavis Pastry Squares. Once the cream is chilled and the squares are cooled, assemble the pastries.",
    "To assemble, take half of the squares and place 1/2 tsp lingonberry jam in the center of each square. Pipe the chilled cream around the jam. Top with the other half of the squares. Then place another 1/2 tsp lingonberry jam on top, and pipe cream around it again. Serve the pastries the same day, to avoid them getting soggy."
  ]
}
